///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GtthIpAddressValidatorDirective, GtthIpAddressViewValidatorDirective } from './ip-address.validator';
import { GtthAssignedNameValidatorDirective, GtthAssignedNameViewValidatorDirective } from './assigned-name.vlidator';

@NgModule({
    imports: [CommonModule],
    declarations: [
        GtthIpAddressValidatorDirective,
        GtthIpAddressViewValidatorDirective,
        GtthAssignedNameValidatorDirective,
        GtthAssignedNameViewValidatorDirective
    ],
    exports: [
        GtthIpAddressValidatorDirective,
        GtthIpAddressViewValidatorDirective,
        GtthAssignedNameValidatorDirective,
        GtthAssignedNameViewValidatorDirective
    ],
    providers: []
})
export class GtthValidationCustomModule {}
